const homepage = {
  path: 'homepage',
  redirect: to => ({
    path: '/unionLogin',
    query: {
      type: 'cj_stu',
      redirect: to.query.redirect || '/studentspace/degree/index'
    }
  })
}

export default homepage
